module.exports = __webpack_public_path__ + "static/media/bank.106d96a7.jpg";